import { officeOwnerConstants } from '../actions/constants';

const initialState = {
    owners: [],
    owner: null,
    ownerLoading: false,
    ownerError: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case officeOwnerConstants.CREATE_OFFICE_OWNER_REQUEST:
            return {
                ...state,
                ownerLoading: true,
                ownerError: null,
            };
        case officeOwnerConstants.CREATE_OFFICE_OWNER_SUCCESS:
            return {
                ...state,
                ownerLoading: false,
                owners: [...state.owners, action.payload.owner],
            };
        case officeOwnerConstants.CREATE_OFFICE_OWNER_FAILURE:
            return {
                ...state,
                ownerLoading: false,
                ownerError: action.payload.error,
            };

        case officeOwnerConstants.GET_OFFICE_OWNERS_REQUEST:
            return {
                ...state,
                ownerLoading: true,
                ownerError: null,
            };
        case officeOwnerConstants.GET_OFFICE_OWNERS_SUCCESS:
            return {
                ...state,
                ownerLoading: false,
                owners: action.payload.owners,
            };
        case officeOwnerConstants.GET_OFFICE_OWNERS_FAILURE:
            return {
                ...state,
                ownerLoading: false,
                ownerError: action.payload.error,
            };

        case officeOwnerConstants.GET_OFFICE_OWNER_REQUEST:
            return {
                ...state,
                ownerLoading: true,
                ownerError: null,
            };
        case officeOwnerConstants.GET_OFFICE_OWNER_SUCCESS:
            return {
                ...state,
                ownerLoading: false,
                owner: action.payload.owner,
            };
        case officeOwnerConstants.GET_OFFICE_OWNER_FAILURE:
            return {
                ...state,
                ownerLoading: false,
                ownerError: action.payload.error,
            };

        case officeOwnerConstants.UPDATE_OFFICE_OWNER_REQUEST:
            return {
                ...state,
                ownerLoading: true,
                ownerError: null,
            };
        case officeOwnerConstants.UPDATE_OFFICE_OWNER_SUCCESS:
            return {
                ...state,
                ownerLoading: false,
                owners: state.owners.map((o) =>
                    o._id === action.payload.owner._id ? action.payload.owner : o
                ),
            };
        case officeOwnerConstants.UPDATE_OFFICE_OWNER_FAILURE:
            return {
                ...state,
                ownerLoading: false,
                ownerError: action.payload.error,
            };

        case officeOwnerConstants.DELETE_OFFICE_OWNER_REQUEST:
            return {
                ...state,
                ownerLoading: true,
                ownerError: null,
            };
        case officeOwnerConstants.DELETE_OFFICE_OWNER_SUCCESS:
            return {
                ...state,
                ownerLoading: false,
                owners: state.owners.filter((o) => o._id !== action.payload.ownerId),
            };
        case officeOwnerConstants.DELETE_OFFICE_OWNER_FAILURE:
            return {
                ...state,
                ownerLoading: false,
                ownerError: action.payload.error,
            };

        default:
            return state;
    }
};